import React, {
  Component, Fragment,
} from 'react';
import PropTypes from 'prop-types';
import { FaTooltipWrapper } from 'Components/UI/Tooltip';
import { PrivateHealthInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import BoolInput from '../Fields/BoolInput';
import CurrencyInput from '../Fields/CurrencyInput';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import { getClientPicklistValue, shouldMakeNotesFieldReadOnly } from './Helpers/ClientPicklist';
import SelectInput from '../Fields/SelectInput';

class PrivateHealthInsuranceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      privateHealthInsuranceInsuredClientId: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getAccountName = this.getAccountName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getAccountName() {
    const { insuredClientOptions } = this.props;
    const { privateHealthInsuranceInsuredClientId } = this.state;
    return getClientPicklistValue(insuredClientOptions, privateHealthInsuranceInsuredClientId) || 'New policy';
  }

  render() {
    const {
      getAccountName,
      onChange,
      props: {
        id, insuredClientOptions, children: removeButton, expanded,
      },
      state: { privateHealthInsuranceInsuredClientId },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getAccountName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <SelectInput
          label="Insured"
          name={`privateHealthInsuranceInsuredClientId.${id}`}
          options={insuredClientOptions}
          answerKey="privateHealthInsuranceInsuredClientId"
          onChange={(name, value) => onChange('privateHealthInsuranceInsuredClientId', value)}
        />
        <TextInput
          placeholder="Insured Notes"
          name={`privateHealthInsuranceInsuredNotes.${id}`}
          answerKey="privateHealthInsuranceInsuredNotes"
          onChange={(name, value) => onChange('privateHealthInsuranceInsuredNotes', value)}
          readOnly={shouldMakeNotesFieldReadOnly(privateHealthInsuranceInsuredClientId)}
        />
        <FaTooltipWrapper title="e.g. Aetna, Cigna, BCBS">
          <TextInput
            placeholder="Insurance provider"
            name={`privateHealthInsuranceProvider.${id}`}
            answerKey="privateHealthInsuranceProvider"
          />
        </FaTooltipWrapper>
        <BoolInput
          label="HSA eligible?"
          name={`privateHealthInsuranceHasHSA.${id}`}
          answerKey="privateHealthInsuranceHasHSA"
          checkedChildren={
            <Fragment>
              <BoolInput
                label="Is this account eligible for investment?"
                name={`privateHealthInsuranceEligibleForInvestment.${id}`}
                answerKey="privateHealthInsuranceEligibleForInvestment"
              />
              <TextInput
                placeholder="Financial institution"
                name={`privateHealthInsuranceInstitution.${id}`}
                answerKey="privateHealthInsuranceInstitution"
              />
              <CurrencyInput
                placeholder="Balance"
                name={`privateHealthInsuranceBalance.${id}`}
                answerKey="privateHealthInsuranceBalance"
              />
              <CurrencyInput
                placeholder="Annual Contributions"
                name={`privateHealthInsuranceAnnualContribution.${id}`}
                answerKey="privateHealthInsuranceAnnualContribution"
              />
            </Fragment>
          }
        />
      </LabeledVerticalExpander>
    );
  }
}

PrivateHealthInsuranceList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  insuredClientOptions: PropTypes.array.isRequired,
};

PrivateHealthInsuranceList.defaultProps = {
  expanded: false,
};

const PrivateHealthInsurance = ({ insuredClientOptions }) => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
      transitionSpeed={0.25}
      height={400}
      title="Private Health Insurance"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Policy - private health insurance"
        addLabel="Add a policy"
        keyPrefix="privateHealthInsurances"
        Of={PrivateHealthInsuranceList}
        childProps={{ insuredClientOptions }}
      />
    </Section>
  );
};

PrivateHealthInsurance.propTypes = {
  insuredClientOptions: PropTypes.array.isRequired,
};

export default PrivateHealthInsurance;
